module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/按钮-媒体播放按钮.1dbeb.png";